import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-loading-button',
  templateUrl: './loading-button.component.html',
  styleUrls: ['./loading-button.component.scss']
})
export class LoadingButtonComponent implements OnInit {
  @Input() isLoading? = false;
  @Input() enabled = true;
  @Input() buttonText: string = "Guardar";
  @Input() buttonTextLoading: string = "Guardando...";


  constructor() { }

  ngOnInit(): void {

  }


}
